module.exports = __webpack_public_path__ + "static/media/instagramStory.4a7fb399.png";